import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";

/**
 * The single app-wide QueryClient. Lives in its own module (rather than App.tsx)
 * so non-component code — the logout helper, the cache-persistence layer — can
 * reach the same instance without importing the render entrypoint.
 */
export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      console.error(`[QueryError] ${JSON.stringify(query.queryKey)}:`, error);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      console.error("[MutationError]:", error);
    },
  }),
  defaultOptions: {
    queries: {
      refetchInterval: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      retry: (failureCount, error) => {
        if (
          isAxiosError(error) &&
          error.response?.status &&
          error.response.status < 500
        ) {
          return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
